import { render } from "./BaseTheme3.vue?vue&type=template&id=4c97e83c&scoped=true"
import script from "./BaseTheme3.vue?vue&type=script&lang=js"
export * from "./BaseTheme3.vue?vue&type=script&lang=js"

import "./BaseTheme3.vue?vue&type=style&index=0&id=4c97e83c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c97e83c"]])

export default __exports__